import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'upmarket-multi_user_education_banner_editable_avatar-click';

/**
 * Event that gets triggered when the user clicks on the editable avatar that opens the profile picture upload modal in the homepage multiuser team education banner
 */
export function trackUpmarketMultiUserEducationBannerEditableAvatarClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
